import React, { useState } from "react";

//Feather
import {
  Trash,
  CornerUpRight
} from "react-feather";

//Momentjs
import moment from "moment";
import "moment/locale/pt-br";

//Svg's components
import File from "../svgs/File";
import Star from "../svgs/Star";

import { useAuth } from "../providers/auth";
import LoadingCenter from "./LoadingCenter";

const FavoriteMessages = ({ messages, isLoading }) => {

    const { user } = useAuth();

  function setMessageId(event) {
    event.preventDefault();
  }

  const renderMessageByType = (message, index) => {

    switch (message.type) {

      case "text": {
        return (
          <li key={index}>
            <a href={"#message-id-"+message.id} style={{ paddingTop: "10px", paddingBottom: "15px", cursor: "pointer" }}>
              <span style={{ margin: "5px 20px" }} className={`message-box-date ${message.sender_id === String(user.id) ? "text-right" : "text-left"}`}>
                {moment(message.createdAt).format("LL")}
              </span>

              <div key={index} className={`message-box  ${message.starred && "msg-starred"} ${message.sender_id === String(user.id) ? "right" : "left"}`} id={"message-id-" + message.id}>

                {message.forward && <div>
                  <span>
                    <CornerUpRight fontSize={16} />
                  </span>

                  {message.forward === "forwarded" && <span className="text-bold ml-10">Mensagem encaminhada</span>}
                  {message.forward === "frequently_forwarded" && <span className="text-bold ml-10">Mensagem encaminhada com frequência</span>}
                </div>}


                {message.deleted && <div className="deleted-text mb-10">
                    <Trash size={18} />

                    <span className="ml-10">
                        Mensagem excluída
                    </span>
                </div>}
                <p>{message.body}</p>
                <span className="message-box-hour">{moment(message.createdAt).format("LT")}</span>
              </div>
            </a>
          </li>
        );
      }

      case "file": case "document": {
        return (
        <li key={index}>
            <a style={{ paddingTop: "10px", paddingBottom: "15px", cursor: "pointer" }} onClick={e => setMessageId(e, message.id)}>
              <span style={{ margin: "5px 20px" }} className={`message-box-date ${message.sender_id === String(user.id) ? "text-right" : "text-left"}`}>
                {moment(message.createdAt).format("LL")}
              </span>

              <div key={index} className={`message-box file-box ${message.starred && "msg-starred"} ${message.sender_id === String(user.id) ? "right" : "left"}`} id={"message-id-" + message.id}>
                {message.forward && <div>
                  <span>
                    <CornerUpRight fontSize={16} />
                  </span>

                  {message.forward === "forwarded" && <span className="text-bold ml-10">Mensagem encaminhada</span>}
                  {message.forward === "frequently_forwarded" && <span className="text-bold ml-10">Mensagem encaminhada com frequência</span>}
                </div>}


                {message.deleted && <div className="deleted-text mb-10">
                    <Trash size={18} />

                    <span className="ml-10">
                        Mensagem excluída
                    </span>
                </div>}

                <div key={index} className="file-wrapper-search">
                    <div className="file">
                      <File />
                      <span>Arquivo</span>
                    </div>
                </div>
                <span className="message-box-hour">{moment(message.createdAt).format("LT")}</span>
              </div>
            </a>
          </li >
        );
      }

      case "image": {
        return (
        <li key={index}>
            <a style={{ paddingTop: "10px", paddingBottom: "15px", cursor: "pointer" }} onClick={e => setMessageId(e, message.id)}>
              <span style={{ margin: "5px 20px" }} className={`message-box-date ${message.sender_id === String(user.id) ? "text-right" : "text-left"}`}>
                {moment(message.createdAt).format("LL")}
              </span>

              <div key={index} className={`message-box box-image ${message.starred && "msg-starred"} ${message.sender_id === String(user.id) ? "right" : "left"}`} id={"message-id-" + message.id}>
                {message.forward && <div>
                  <span>
                    <CornerUpRight fontSize={16} />
                  </span>

                  {message.forward === "forwarded" && <span className="text-bold ml-10">Mensagem encaminhada</span>}
                  {message.forward === "frequently_forwarded" && <span className="text-bold ml-10">Mensagem encaminhada com frequência</span>}
                </div>}


                {message.deleted && <div className="deleted-text mb-10">
                    <Trash size={18} />

                    <span className="ml-10">
                        Mensagem excluída
                    </span>
                </div>}

                <div key={index} className="message-image">
                    <img src={message.body} />
                </div>
                <span className="message-box-hour">{moment(message.createdAt).format("LT")}</span>
              </div>
            </a>
          </li >
        );
      }

      case "sticker": {
        return (
        <li key={index}>
            <a style={{ paddingTop: "10px", paddingBottom: "15px", cursor: "pointer" }} onClick={e => setMessageId(e, message.id)}>
              <span style={{ margin: "5px 20px" }} className={`message-box-date ${message.sender_id === String(user.id) ? "text-right" : "text-left"}`}>
                {moment(message.createdAt).format("LL")}
              </span>

              <div key={index} className={`message-box box-sticker ${message.starred && "msg-starred"} ${message.sender_id === String(user.id) ? "right" : "left"}`} id={"message-id-" + message.id}>
                {message.forward && <div>
                  <span>
                    <CornerUpRight fontSize={16} />
                  </span>

                  {message.forward === "forwarded" && <span className="text-bold ml-10">Mensagem encaminhada</span>}
                  {message.forward === "frequently_forwarded" && <span className="text-bold ml-10">Mensagem encaminhada com frequência</span>}
                </div>}


                {message.deleted && <div className="deleted-text mb-10">
                    <Trash size={18} />

                    <span className="ml-10">
                        Mensagem excluída
                    </span>
                </div>}

                <div key={index} className="message-sticker">
                    <img src={message.body} />
                </div>
                <span className="message-box-hour">{moment(message.createdAt).format("LT")}</span>
              </div>
            </a>
          </li >
        );
      }

      case "video": {
        return (
        <li key={index}>
            <a style={{ paddingTop: "10px", paddingBottom: "15px", cursor: "pointer" }} onClick={e => setMessageId(e, message.id)}>
              <span style={{ margin: "5px 20px" }} className={`message-box-date ${message.sender_id === String(user.id) ? "text-right" : "text-left"}`}>
                {moment(message.createdAt).format("LL")}
              </span>

              <div key={index} className={`message-box box-image ${message.starred && "msg-starred"} ${message.sender_id === String(user.id) ? "right" : "left"}`} id={"message-id-" + message.id}>
                {message.forward && <div>
                  <span>
                    <CornerUpRight fontSize={16} />
                  </span>

                  {message.forward === "forwarded" && <span className="text-bold ml-10">Mensagem encaminhada</span>}
                  {message.forward === "frequently_forwarded" && <span className="text-bold ml-10">Mensagem encaminhada com frequência</span>}
                </div>}


                {message.deleted && <div className="deleted-text mb-10">
                    <Trash size={18} />

                    <span className="ml-10">
                        Mensagem excluída
                    </span>
                </div>}

                <div className="message-image">
                    <video src={message.body} controls />
                </div>
                <span className="message-box-hour">{moment(message.createdAt).format("LT")}</span>
              </div>
            </a>
          </li >
        );
      }

      case "audio": case "voice": {
        return (
        <li key={index}>
            <a style={{ paddingTop: "10px", paddingBottom: "15px", cursor: "pointer" }} onClick={e => setMessageId(e, message.id)}>
              <span style={{ margin: "5px 20px" }} className={`message-box-date ${message.sender_id === String(user.id) ? "text-right" : "text-left"}`}>
                {moment(message.createdAt).format("LL")}
              </span>

              <div key={index} className={`message-box box-image ${message.starred && "msg-starred"} ${message.sender_id === String(user.id) ? "right" : "left"}`} id={"message-id-" + message.id}>
                {message.forward && <div>
                  <span>
                    <CornerUpRight fontSize={16} />
                  </span>

                  {message.forward === "forwarded" && <span className="text-bold ml-10">Mensagem encaminhada</span>}
                  {message.forward === "frequently_forwarded" && <span className="text-bold ml-10">Mensagem encaminhada com frequência</span>}
                </div>}


                {message.deleted && <div className="deleted-text mb-10">
                    <Trash size={18} />

                    <span className="ml-10">
                        Mensagem excluída
                    </span>
                </div>}

                <div className="message-audio">
                    <audio controls>
                        <source src={message.body} />
                    </audio>
                </div>
                <span className="message-box-hour">{moment(message.createdAt).format("LT")}</span>
              </div>
            </a>
          </li >
        );
      }
    }
  }

  return (
    <ul className="ul-messages clear-ul full-ul">
      {messages && messages.map((message, index) => renderMessageByType(message, index))}

      {isLoading ? (
        <LoadingCenter />
      ) : (
        messages.length <= 0 && <div className="div-center pt-20 pl-20 pr-20 text-center">
          <Star />
          <span className="chat-user-name">Favoritas</span>
          <span className="chat-user-username">
            As suas mensagens favoritas ficarão aqui.
          </span>
        </div>
      )}
    </ul>
  );
}

export default FavoriteMessages;
